interface SelectionToolbarProps {
  rect: DOMRect
  onTranslate: () => void
  onVisualize: () => void
  onSavePhrase: () => void
}

export function SelectionToolbar({ rect, onTranslate, onVisualize, onSavePhrase }: SelectionToolbarProps) {
  const gap = 6
  const toolbarWidth = 270
  const viewportPadding = 8

  let top = rect.top - gap - 48
  let left = rect.left + rect.width / 2 - toolbarWidth / 2

  if (left < viewportPadding) left = viewportPadding
  if (left + toolbarWidth > window.innerWidth - viewportPadding) {
    left = window.innerWidth - viewportPadding - toolbarWidth
  }

  if (top < viewportPadding) {
    top = rect.bottom + gap
  }

  const buttonClass =
    'px-3 py-2 min-h-[44px] text-xs font-light text-accent hover:bg-surface-bg active:bg-surface-bg transition-colors duration-200'

  return (
    <div
      className="fixed z-50 flex items-center rounded-md border border-border-divider bg-page-bg shadow-md animate-fade-in overflow-hidden"
      style={{ top, left }}
    >
      <button onClick={onTranslate} className={buttonClass}>
        Translate
      </button>
      <div className="w-px h-6 bg-border-divider" />
      <button onClick={onVisualize} className={buttonClass}>
        Visualize
      </button>
      <div className="w-px h-6 bg-border-divider" />
      <button onClick={onSavePhrase} className={buttonClass}>
        Save phrase
      </button>
    </div>
  )
}
